@if (prettified !== '' && loading) {
  <div class="loading fx-fill">
    <mat-spinner diameter="20" />
  </div>
}
<div [innerHTML]="prettifiedString | sanitizeHtml"></div>
